import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { authService, PermissionScope } from '@/services/AuthService'
import { useUserRoles } from '@/contexts/UserRolesContext'
import './HeaderBar.css'
import { ChevronDown, Home } from 'lucide-react'
import { usePartner } from '@/contexts/partnerContext'
import { RESOURCES } from '@/constants/resources'

export default function HeaderBar() {
  const [showUserMenu, setShowUserMenu] = useState(false)
  const [showPartnerMenu, setShowPartnerMenu] = useState(false)
  const userDropdownMenu = useRef<HTMLDivElement>(null)
  const partnerDropdownMenu = useRef<HTMLDivElement>(null)
  const { currentRoles, loading } = useUserRoles()
  const { impersonatedPartnerId, setImpersonatedPartner, partners, clearImpersonatedPartner } = usePartner();

  const userName = authService.getUsername()

  const getRoleDisplayName = () => {
    if (loading) return "Loading...";
    if (!currentRoles || currentRoles.length === 0) return "No Role Assigned";
    return currentRoles[0];
  }

  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  }

  const getPartnerName = () => {
    if (impersonatedPartnerId === null) return null
    return partners.find(partner => partner.id == impersonatedPartnerId)?.name
  }

  

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userDropdownMenu.current && !userDropdownMenu.current.contains(event.target as Node)) {
        setShowUserMenu(false)
      }

      if (partnerDropdownMenu.current && !partnerDropdownMenu.current.contains(event.target as Node)) {
        setShowPartnerMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])


  return (
    <header className="header-bar">
      <div className="header-left">
        <Link to="/" className="header-home-button">
          <Home size={20} className="home-icon" />
          Home
        </Link>
      </div>

      <div className="header-right">
      {authService.hasPermission(RESOURCES.PARTNERS, PermissionScope.READ) &&
        (
          <div className="partner-cluster" ref={partnerDropdownMenu}>
          <button
            className="partner-pill"
            onClick={() => setShowPartnerMenu(!showPartnerMenu)}
            aria-label="Partner menu"
          >
            <div className="partner-info">
              <span className="partner-title">Channel Partner</span>
              <span className="partner-name">{getPartnerName() ?? 'No partner selected'} </span>
            </div>
            <ChevronDown size={14} strokeWidth={3} className={`chevron-icon ${showPartnerMenu ? 'open' : ''}`} />
          </button>

          {showPartnerMenu && (
            <div className="partner-dropdown-menu">
              <div className="dropdown-header">Select a partner</div>
              <div className="partner-list">
                {partners.map((partner) => (
                  <button onClick={() => setImpersonatedPartner(partner.id)} className={`dropdown-item ${impersonatedPartnerId === partner.id ? 'active' : ''}`}>
                  {partner.name}
                </button>
                ))}
              </div>
             <hr className="partner-divider" />
             <button className="dropdown-item" onClick={() => clearImpersonatedPartner()} >Clear partner</button>
            </div>
          )}
        </div>
        )
      }
      

        <div className="user-cluster" ref={userDropdownMenu}>
          <button
            className="user-pill"
            onClick={() => setShowUserMenu(!showUserMenu)}
            aria-label="User menu"
          >
            <div className="user-avatar">
              {getInitials(userName)}
            </div>
            <div className="user-info">
              <span className="user-name">{userName}</span>
              <span className="user-role">{getRoleDisplayName()}</span>
            </div>
            <ChevronDown size={14} strokeWidth={3} className={`chevron-icon ${showUserMenu ? 'open' : ''}`} />
          </button>

          {showUserMenu && (
            <div className="user-dropdown-menu">
              <div className="dropdown-header">Actions</div>
              <button className="dropdown-item" onClick={() => authService.logout()}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
